import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import SelectableUser from './selectable-user';

const UserPicker = ({ handleHide, users, mentionedUsers, updateMentionedUsers }) => {
  return (
    <div className='user-picker__wrapper'>
      <div className='d-flex flex-direction-row justify-content-between align-items-center w-100 mb-3'>
        <div className='user-picker__header'>
          <button type='button' className='border-0 bg-transparent' onClick={handleHide}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>

          <span className='picker__headings'>Tag</span>
        </div>
        <button
          type='button'
          className='btn-custom btn-custom--primary btn-custom--small'
          onClick={handleHide}
        >
          Done {mentionedUsers.length > 0 && <>({mentionedUsers.length} selected)</>}
        </button>
      </div>
      <div className='user-picker__list'>
        {users.map(user => (
          <SelectableUser
            key={user.uri}
            user={user}
            isMentioned={mentionedUsers.includes(user.username)}
            updateMentionedUsers={updateMentionedUsers}
          />
        ))}
      </div>
    </div>
  );
};

UserPicker.propTypes = {
  handleHide: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      uri: PropTypes.string.isRequired,
    })
  ).isRequired,
  mentionedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateMentionedUsers: PropTypes.func.isRequired,
};

export default UserPicker;
